<template>
    <div class="side-nav-header ut-py-3 ut-px-6"
         :class="{'ut-cursor-pointer' : hasPortalAccount}">
        <div class="ut-flex" @click="isActive = !isActive">
            <figure class="ut-circle-img ut-h-8 ut-w-8 ut-bg-neutral-001 ut-flex">
                <img :src="agentProfileImage" alt="" class="ut-flex-shrink-0 ga-event" data-category="Sidebar" data-eventlabel="agent image">
            </figure>
            <div class="ut-flex-1 ut-ml-2 ut-text-neutral-001 ut-opacity-75 agent-name ga-event" data-category="Sidebar">
                {{ agentName }}
            </div>
            <div v-if="hasPortalAccount || !isSignUpPage"
                 :class="{ 'ut-toggle-arrow-up': isActive, 'ut-toggle-arrow-down' : !isActive}">
            </div>
        </div>
        <transition-fade>
          <ul class="ut-px-7 ut-py ut-text-N001 ut-opacity-75 ut-text-sm ut-mt-2" v-if="isActive">
            <router-link v-if="agentid" tag="li"
                          exact-active-class="active"
                          :to="{ name: 'account',
                          params : params,
                          hash: '#your-contact-details'}" 
                          class="ga-event"
                          data-category="Sidebar">Your account</router-link>
            <li v-if="isAuthenticated" @click="clickedLogout" class="ga-event" data-category="Sidebar">Logout</li>
            <li v-else @click="clickedLogout" class="ga-event" data-category="Sidebar">Login</li>
          </ul>
        </transition-fade>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import TransitionFade from '@/components/TransitionFade.vue';

export default {
  name: 'SideNavAgentHeader',
  props: {
    name: {
      type: String,
      required: true,
    },
    imgRef: {
      type: String,
      required: false,
    },
    agentid: {
      type: Number,
      required: false,
    },
    agentkey: {
      type: String,
      required: false,
    },
  },
  components: {
    TransitionFade,
  },
  data() {
    return {
      isActive: false,
    };
  },
  computed: {
    ...mapGetters('userStore', [
      'hasPortalAccount',
      'isAuthenticated',
    ]),
    agentName() {
      return `Welcome ${this.name}`;
    },
    agentProfileImage() {
      if (this.imgRef) {
        return `${process.env.VUE_APP_CDN_URL}/img/agent/${this.imgRef}`;
      }
      return require('../assets/styles/frontend-library/images/user-solid-dark.svg');
    },
    isSignUpPage() {
      return this.$route.name === 'signup';
    },
    params() {
      const params = {
        ak: this.$route.params.ak,
        uk: this.$route.params.uk,
      };
      if (!params.ak) {
        params.ak = this.agentkey;
      }
      return params;
    },
  },
  methods: {
    ...mapActions('userStore', {
      logOutUser: 'logOutUser',
    }),
    clickedLogout() {
      this.logOutUser().then(() => {
        const currentRoute = this.$route;
        this.$router.push({
          name: 'login',
          query: { redirect: currentRoute.name },
          params: this.params,
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .side-nav-header {
      background-color: #232323;
  }

  ul {
    li {
      letter-spacing: 0.26px;
      line-height: 36px;
      @apply ut-text-neutral-001 ut-opacity-75 ut-text-sm;

      &:before {
        content: "\00B7";
        @apply ut-mr-2 ut-w-8 ut-text-center ut-inline-block ut-text-neutral-001 ut-opacity-25;
      }
    }
  }
</style>
